import { Component } from '@angular/core';
import { AppService } from '../app.service';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.css']
})
export class StartComponent  {

  showTip: boolean = true;

  constructor(public appService: AppService) { }

  /** get text in right language 
  * @param {string} tag - text to load
  */
 get(tag: string): string{
  return this.appService.get(tag);
 }
}
